export interface AvisoObraItem {
    nroObra: string;
    direccion: string;
    localidad: string;
    provincia: string;
    programa: string;
    tipoObra: string;
    fechaInicio: string;
    fechaFin: string;
    idEstado: number;
    fechaAlta: string;
}

export interface AvisoObraResponse {
    data: {
        data: AvisoObraItem[];
        total: number;
    };
}

export type ActionType = 'Suspender' | 'Extender';

export interface ExtensionFormData {
    fechaExtension: string;
}

export interface SuspensionFormData {
    fechaSuspension: string;
    fechaReinicio: string;
}

export enum EstadoAvisoObraEnum {
    EN_REVISION = 1,
    PENDIENTE_VISITA = 2,
    PRESENTADO = 3,
    RECIBIDO = 4,
    BORRADOR = 5,
    RECHAZADO = 6,
    FINALIZADO = 7,
    SUSPENDIDO = 8,
    EN_EXTENSION = 9,
    VENCIDO = 10
}

export const getEstadoAvisoObraLabel = (estado: EstadoAvisoObraEnum | number): string => {
    switch (estado) {
        case EstadoAvisoObraEnum.EN_REVISION:
            return 'En Revisión';
        case EstadoAvisoObraEnum.PENDIENTE_VISITA:
            return 'Pendiente Visita';
        case EstadoAvisoObraEnum.PRESENTADO:
            return 'Presentado';
        case EstadoAvisoObraEnum.RECIBIDO:
            return 'Recibido';
        case EstadoAvisoObraEnum.BORRADOR:
            return 'Borrador';
        case EstadoAvisoObraEnum.RECHAZADO:
            return 'Rechazado';
        case EstadoAvisoObraEnum.FINALIZADO:
            return 'Finalizado';
        case EstadoAvisoObraEnum.SUSPENDIDO:
            return 'Suspendido';
        case EstadoAvisoObraEnum.EN_EXTENSION:
            return 'En Extensión';
        case EstadoAvisoObraEnum.VENCIDO:
            return 'Vencido';
        default:
            return 'Desconocido';
    }
};
